import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import { Size } from 'types';

export type StyleProps = {
  size: Size;
  selected: boolean;
  amount: number;
  hasParticipant: boolean;
};

const borderWidth = '3px';

const getMinAmountWidth = (size: Size): number => {
  switch (size) {
    case 'large':
      return 82;
    case 'medium':
      return 82;
    case 'small':
      return 66;
  }
};

const calcWidth = (length: number) => {
  if (length > 6) {
    return 50 + 5 * length;
  }
};

const getWidth = (size: Size): number | string => {
  switch (size) {
    case 'large':
      return 80;
    case 'medium':
      return 68;
    case 'small':
      return 56;
  }
};

const getHeight = (size: Size): number | string => {
  switch (size) {
    case 'large':
      return 80;
    case 'medium':
      return 68;
    case 'small':
      return 56;
  }
};

const getNameMarginTop = (size: Size): number | string => {
  switch (size) {
    case 'large':
      return '8px';
    case 'medium':
      return '14px';
    case 'small':
      return '5px';
  }
};

const getNameFontSize = (size: Size): number | string => {
  switch (size) {
    case 'large':
      return '14px';
    case 'medium':
      return '18px';
    case 'small':
      return '12px';
  }
};

const getNameLineHeight = (size: Size): number | string => {
  switch (size) {
    case 'large':
      return '16px';
    case 'medium':
      return '22px';
    case 'small':
      return '14px';
  }
};

const getImageBoxShadow = (isShow: boolean) => {
  if (isShow) {
    return `#3ad4dc 0 0px 0px ${borderWidth} inset`;
  }
};

export const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    root: () => ({
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }),
    container: (props) => ({
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: `calc(${getWidth(props.size)}px + 10px)`,
      height: `calc(${getHeight(props.size)}px + 10px)`,
      boxShadow: getImageBoxShadow(props.selected),
      borderRadius: '50%',
      transition: 'box-shadow 0.1s ease-in-out',
    }),
    image: (props) => ({
      width: getWidth(props.size),
      height: getHeight(props.size),
      borderRadius: '50%',
      overflow: 'hidden',
    }),
    name: (props) => ({
      marginTop: getNameMarginTop(props.size),
      fontSize: getNameFontSize(props.size),
      lineHeight: getNameLineHeight(props.size),
      wordBreak: props.hasParticipant ? 'inherit' : 'break-word',
      width: props.hasParticipant ? `calc(${getWidth(props.size)}px + 10px)` : 'initial'
    }),
    amount: (props) => ({
      position: 'absolute',
      top: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: calcWidth(`${props.amount}`.length),
      minWidth: getMinAmountWidth(props.size),
      height: 20,
      background: 'linear-gradient(0deg, rgba(26, 17, 24, 0.08), rgba(26, 17, 24, 0.08)), #FFFFFF;',
      backdropFilter: 'blur(56px)',
      borderRadius: 7,
      transform: `translateY(calc(-100% + ${borderWidth}))`,

      [theme.breakpoints.up('md')]: {
        background: '#F2F2F6',
      },
    }),
    count: {
      fontSize: '15px',
      fontWeight: 600,
    },
    description: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      padding: '3px 8px',
      borderRadius: 15,
      background: 'rgba(39, 34, 255, 0.1)',

      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    text: {
      fontSize: '12px',
      lineHeight: '14px',
      color: '#2722FF',
    },
    placeholder: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(128.37deg, #3cd4dd 7.97%, #017ab2 85.8%)',
    },
    shortName: (props) => ({
      fontSize: props.size === 'small' ? 18 : 24,
      lineHeight: props.size === 'small' ? '21px' : '28px',
    }),
  })
);
